// ══════════════════════════════════════════════════════
// SERVIÇO DE NOTIFICAÇÕES  
// ══════════════════════════════════════════════════════
// @TODO: Implementar endpoints no backend para:
// - GET /notifications/email?filters...
// - GET /notifications/whatsapp?filters...
// - GET /notifications/email/:id
// - GET /notifications/whatsapp/:id
// - DELETE /notifications/email/:id
// - DELETE /notifications/whatsapp/:id

import api from './api';
import { 
  EmailNotificationLog,
  WhatsappNotificationLog,
  NotificationFilters,
  PaginatedResponse
} from '../types/notification.types';

const API_BASE = '/notifications';

/**
 * Notificações por E-mail
 */
export const emailNotificationService = {
  /**
   * Buscar histórico de emails enviados/pendentes
   */
  async getHistory(
    page: number = 1,
    pageSize: number = 20,
    filters?: NotificationFilters
  ): Promise<PaginatedResponse<EmailNotificationLog>> {
    try {
      const params = new URLSearchParams();
      params.append('page', page.toString());
      params.append('pageSize', pageSize.toString());

      if (filters?.startDate) 
        params.append('startDate', filters.startDate.toISOString());
      if (filters?.endDate) 
        params.append('endDate', filters.endDate.toISOString());
      if (filters?.customerId) 
        params.append('customerId', filters.customerId);
      if (filters?.type) 
        params.append('type', filters.type);
      if (filters?.status) 
        params.append('status', filters.status);
      if (filters?.searchTerm) 
        params.append('search', filters.searchTerm);

      const { data } = await api.get(`${API_BASE}/email/history?${params}`);
      return data;
    } catch (error) {
      console.error('Erro ao buscar histórico de emails:', error);
      throw error;
    }
  },

  /**
   * Obter detalhes de um email específico
   */
  async getDetails(id: string): Promise<EmailNotificationLog> {
    try {
      const { data } = await api.get(`${API_BASE}/email/${id}`);
      return data;
    } catch (error) {
      console.error('Erro ao buscar detalhes do email:', error);
      throw error;
    }
  },

  /**
   * Deletar registro de email
   */
  async delete(id: string): Promise<void> {
    try {
      await api.delete(`${API_BASE}/email/${id}`);
    } catch (error) {
      console.error('Erro ao deletar email:', error);
      throw error;
    }
  },

  /**
   * Exportar histórico em CSV
   */
  async exportCSV(filters?: NotificationFilters): Promise<Blob> {
    try {
      const params = new URLSearchParams();
      params.append('format', 'csv');

      if (filters?.startDate) 
        params.append('startDate', filters.startDate.toISOString());
      if (filters?.endDate) 
        params.append('endDate', filters.endDate.toISOString());
      if (filters?.customerId) 
        params.append('customerId', filters.customerId);
      if (filters?.type) 
        params.append('type', filters.type);
      if (filters?.status) 
        params.append('status', filters.status);

      const { data } = await api.get(`${API_BASE}/email/export?${params}`, {
        responseType: 'blob',
      });
      return data;
    } catch (error) {
      console.error('Erro ao exportar emails:', error);
      throw error;
    }
  },
};

/**
 * Notificações por WhatsApp
 */
export const whatsappNotificationService = {
  /**
   * Buscar histórico de mensagens enviadas/pendentes
   */
  async getHistory(
    page: number = 1,
    pageSize: number = 20,
    filters?: NotificationFilters
  ): Promise<PaginatedResponse<WhatsappNotificationLog>> {
    try {
      const params = new URLSearchParams();
      params.append('page', page.toString());
      params.append('pageSize', pageSize.toString());

      if (filters?.startDate) 
        params.append('startDate', filters.startDate.toISOString());
      if (filters?.endDate) 
        params.append('endDate', filters.endDate.toISOString());
      if (filters?.customerId) 
        params.append('customerId', filters.customerId);
      if (filters?.type) 
        params.append('type', filters.type);
      if (filters?.status) 
        params.append('status', filters.status);
      if (filters?.searchTerm) 
        params.append('search', filters.searchTerm);

      const { data } = await api.get(`${API_BASE}/whatsapp/history?${params}`);
      return data;
    } catch (error) {
      console.error('Erro ao buscar histórico de WhatsApp:', error);
      throw error;
    }
  },

  /**
   * Obter detalhes de uma mensagem específica
   */
  async getDetails(id: string): Promise<WhatsappNotificationLog> {
    try {
      const { data } = await api.get(`${API_BASE}/whatsapp/${id}`);
      return data;
    } catch (error) {
      console.error('Erro ao buscar detalhes da mensagem:', error);
      throw error;
    }
  },

  /**
   * Deletar registro de mensagem
   */
  async delete(id: string): Promise<void> {
    try {
      await api.delete(`${API_BASE}/whatsapp/${id}`);
    } catch (error) {
      console.error('Erro ao deletar mensagem:', error);
      throw error;
    }
  },

  /**
   * Exportar histórico em CSV
   */
  async exportCSV(filters?: NotificationFilters): Promise<Blob> {
    try {
      const params = new URLSearchParams();
      params.append('format', 'csv');

      if (filters?.startDate) 
        params.append('startDate', filters.startDate.toISOString());
      if (filters?.endDate) 
        params.append('endDate', filters.endDate.toISOString());
      if (filters?.customerId) 
        params.append('customerId', filters.customerId);
      if (filters?.type) 
        params.append('type', filters.type);
      if (filters?.status) 
        params.append('status', filters.status);

      const { data } = await api.get(`${API_BASE}/whatsapp/export?${params}`, {
        responseType: 'blob',
      });
      return data;
    } catch (error) {
      console.error('Erro ao exportar mensagens:', error);
      throw error;
    }
  },
};
